(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,4096],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8163);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FeaturedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9447);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4002);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5186);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2997);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7649);
/* harmony import */ var _components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3078);
/* harmony import */ var _components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9879);
/* harmony import */ var _components_Layout_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3666);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);







swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"].use */ .Z.use([
    swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
]);
function FeaturedProducts(param) {
    var featuredProductsData = param.featuredProductsData, _title = param.title, title = _title === void 0 ? "" : _title, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "" : _bgColor, _indexComponent = param.indexComponent, indexComponent = _indexComponent === void 0 ? "" : _indexComponent, _shouldShowChip = param.shouldShowChip, shouldShowChip = _shouldShowChip === void 0 ? false : _shouldShowChip, _url = param.url, url = _url === void 0 ? "" : _url;
    var pagination = {
        clickable: true
    };
    var navigation = {
        nextEl: "#produtos-swiper-button__next".concat(indexComponent),
        prevEl: "#produtos-swiper-button__prev".concat(indexComponent)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            backgroundColor: bgColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray200 */ .Ce.mglGray200,
            paddingOnBottom: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    texto: title || "Produtos em Alta",
                    color: "black",
                    showChip: shouldShowChip,
                    alignRight: shouldShowChip,
                    urlRedirect: url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mt-4 [&_.container-swiper\\_\\_next]:-right-2 [&_.container-swiper\\_\\_prev]:-left-2 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:transition-opacity [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-in-out [&_.swiper-pagination]:hidden desktop:[&_.swiper-pagination]:block [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:w-[26px] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:bg-mglBlue400 [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .t, {
                            centeredSlidesBounds: true,
                            speed: 1000,
                            pagination: pagination,
                            navigation: navigation,
                            breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    slidesPerGroup: 1,
                                    spaceBetween: 16
                                },
                                768: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                    spaceBetween: 16
                                },
                                1660: {
                                    slidesPerView: 6,
                                    slidesPerGroup: 6,
                                    spaceBetween: 16
                                }
                            },
                            children: featuredProductsData.map(function(product) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        title: product.titulo,
                                        image: product.imagem,
                                        url: product.url
                                    })
                                }, product.url);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-swiper container-swiper__prev",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "produtos-swiper-button__prev".concat(indexComponent),
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(180deg)"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-swiper container-swiper__next",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "produtos-swiper-button__next".concat(indexComponent),
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(360deg)"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoSliders; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9447);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4002);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5186);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2997);
/* harmony import */ var _components_Layout_WrapperDestaque__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(248);
/* harmony import */ var _components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9879);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5877);
/* harmony import */ var _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2140);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9659);
/* harmony import */ var _components_Layout_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3666);










swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"].use */ .Z.use([
    swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
]);
function VideoSliders(param) {
    var featuredVideosData = param.featuredVideosData, _isOnProduct = param.isOnProduct, isOnProduct = _isOnProduct === void 0 ? false : _isOnProduct, _setBackgroundColor = param.setBackgroundColor, setBackgroundColor = _setBackgroundColor === void 0 ? "bg-mglGray50" : _setBackgroundColor, _useTitle = param.useTitle, useTitle = _useTitle === void 0 ? true : _useTitle;
    var ref;
    var variants = {
        TituloContent: {
            isOnProduct: {
                true: "max-w-[initial]",
                false: "max-w-[calc(100%-3rem)] tablet:max-w-[83.33%]"
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var videoSlidersSpan = currentSpan && currentSpan.startChild({
        op: "videoSliders"
    });
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("phone"), 1), isMobile = ref1[0];
    var pagination = {
        clickable: true
    };
    var navigation = {
        nextEl: "#videos-swiper-button__next",
        prevEl: "#videos-swiper-button__prev"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_WrapperDestaque__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                backgroundColor: setBackgroundColor || "bg-mglGray50",
                paddingOnlyTop: isOnProduct,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("mx-auto my-0 w-full", variants.TituloContent.isOnProduct[isOnProduct.toString()]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            texto: "V\xeddeos",
                            urlRedirect: "/video/",
                            color: "black",
                            showChip: !isOnProduct,
                            alignRight: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative [&_.container-swiper\\_\\_next]:right-6 [&_.container-swiper\\_\\_prev]:left-6 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-ease [&_.swiper-pagination]:bottom-0 [&_.swiper-pagination]:pr-[8.333%] [&_.swiper-pagination]:text-right [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:w-[26px] [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-mglBlue400 [&_.swiper-pagination-bullet-active.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_11__/* .Swiper */ .t, {
                                centeredSlidesBounds: true,
                                className: "py-0",
                                centeredSlides: isMobile,
                                grabCursor: true,
                                speed: 1000,
                                pagination: pagination,
                                navigation: navigation,
                                breakpoints: {
                                    0: {
                                        slidesPerView: 1.1,
                                        spaceBetween: 16,
                                        slidesPerGroup: 1
                                    },
                                    530: {
                                        slidesPerView: 2,
                                        spaceBetween: 16,
                                        slidesPerGroup: 2
                                    },
                                    980: {
                                        slidesPerView: isOnProduct ? 3 : 4,
                                        spaceBetween: 16,
                                        slidesPerGroup: isOnProduct ? 3 : 4
                                    }
                                },
                                children: featuredVideosData.map(function(video) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative h-[300px] w-full overflow-hidden rounded-lg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                title: video.titulo,
                                                image: video.imagem,
                                                url: video.url,
                                                onlyImage: !useTitle,
                                                onlyImageAndText: useTitle,
                                                fullWidth: true
                                            })
                                        })
                                    }, "video-sliders-".concat(video.url));
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container-swiper container-swiper__prev",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "videos-swiper-button__prev",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(180deg)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container-swiper container-swiper__next",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "videos-swiper-button__next",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(360deg)"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            videoSlidersSpan && videoSlidersSpan.finish()
        ]
    });
}


/***/ }),

/***/ 7586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




function OfferBanner(param) {
    var _isOnHome = param.isOnHome, isOnHome = _isOnHome === void 0 ? false : _isOnHome, _phrase = param.phrase, phrase = _phrase === void 0 ? "Siga o Canal do CT no WhatsApp" : _phrase, _link = param.link, link = _link === void 0 ? "https://canalte.ch/canaltech-no-whatsapp-site" : _link;
    var textBanner = phrase;
    var Container = function(param) {
        var children = param.children;
        if (isOnHome) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative flex w-full flex-col flex-wrap content-center justify-center bg-mglGray50 pt-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-6 max-[500px]:pr-12",
                children: children
            })
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex w-full items-center justify-center gap-2 rounded bg-[#25D366] p-4", !isOnHome && "mb-8"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: " text-sm leading-tight text-mglGray900 tablet:text-base",
                    children: textBanner
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: link,
                    target: "_blank",
                    className: "canal-ct-wpp flex appearance-none items-center gap-1 rounded-3xl border-0 bg-mglGray900 px-4 py-2 text-xs text-mglGray50 outline-none transition-opacity hover:opacity-80 focus:opacity-80",
                    title: textBanner,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            icon: "mdi:whatsapp"
                        }),
                        " Entrar"
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 3666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





function Card(param) {
    var title = param.title, url = param.url, image = param.image, _chipText = param.chipText, chipText = _chipText === void 0 ? "ver detalhes" : _chipText, _rumor = param.rumor, rumor = _rumor === void 0 ? false : _rumor, _onlyImage = param.onlyImage, onlyImage = _onlyImage === void 0 ? false : _onlyImage, _onlyImageAndText = param.onlyImageAndText, onlyImageAndText = _onlyImageAndText === void 0 ? false : _onlyImageAndText, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("group flex min-h-[220px] w-full cursor-pointer flex-col items-center rounded-lg bg-mglGray50 no-underline transition-all duration-300", onlyImage || onlyImageAndText ? "p-0" : "p-4", fullWidth ? "w-full" : ""),
            title: title,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative flex aspect-video justify-center [&>figure>div>img]:object-contain", fullWidth ? "w-full" : onlyImageAndText || onlyImage ? "max-h-[240px]" : "max-h-[120px] "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: image.url,
                            blurhash: image.blurhash,
                            width: onlyImage || onlyImageAndText ? null : 100,
                            height: onlyImage || onlyImageAndText ? null : 100,
                            alt: title
                        }),
                        rumor && !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-[9.5em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-[0.6875rem] uppercase leading-loose text-mglGray50 hover:[&>div>span>svg>path>fill]:text-mglGray50",
                            children: "Rumor"
                        })
                    ]
                }),
                onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mt-4 font-medium text-mglGray900 tablet:mx-0 tablet:mb-0",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-10 items-center justify-center text-center text-sm font-medium text-mglGray900 no-underline",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    texto: chipText,
                    chipSize: "medium",
                    posIcon: "chevron-right",
                    color: "black",
                    borderColor: "black",
                    title: title,
                    className: "group-hover:border group-hover:border-mglGray900 group-hover:bg-mglGray900 group-hover:text-mglGray50 [&>span>svg]:transition-colors group-hover:[&>span>svg]:text-mglGray50"
                })
            ]
        })
    });
}


/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ DealsSecondaryValue; },
/* harmony export */   "EN": function() { return /* binding */ DealsContentContainer; },
/* harmony export */   "GA": function() { return /* binding */ DealsBoxSubheading; },
/* harmony export */   "KG": function() { return /* binding */ DealsContentLink; },
/* harmony export */   "KO": function() { return /* binding */ DealsBoxContainer; },
/* harmony export */   "KR": function() { return /* binding */ DealsBoxTitleContainer; },
/* harmony export */   "MU": function() { return /* binding */ DealsChipButtonContainer; },
/* harmony export */   "O5": function() { return /* binding */ DealsContentTitle; },
/* harmony export */   "QG": function() { return /* binding */ DealsProductImageContainer; },
/* harmony export */   "Wy": function() { return /* binding */ DealsColumn; },
/* harmony export */   "Y9": function() { return /* binding */ DealsUnitContainer; },
/* harmony export */   "hU": function() { return /* binding */ DealsValue; },
/* harmony export */   "kx": function() { return /* binding */ DealsCents; },
/* harmony export */   "nN": function() { return /* binding */ DealsContentTextContainer; },
/* harmony export */   "qb": function() { return /* binding */ DealsBoxWrapper; },
/* harmony export */   "qr": function() { return /* binding */ DealsPartnerContainer; },
/* harmony export */   "t3": function() { return /* binding */ DealsRow; },
/* harmony export */   "te": function() { return /* binding */ DealsContentUnitContainer; },
/* harmony export */   "ud": function() { return /* binding */ DealsContentWrapper; },
/* harmony export */   "vi": function() { return /* binding */ DealsValueContainer; },
/* harmony export */   "vw": function() { return /* binding */ DealsProductDescription; },
/* harmony export */   "xy": function() { return /* binding */ DealsBoxTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    DealsBoxWrapper: {
        limitMaxWidth: {
            true: "p-0",
            false: "[&>div]:w-full [&>div]:max-w-[calc(100%-3rem)] desktop:[&>div]:max-w-[83.33%]"
        }
    },
    DealsBoxTitleContainer: {
        noPadding: {
            true: "p-0",
            false: ""
        }
    },
    DealsRow: {
        isProduct: {
            true: "",
            false: "flex-col"
        }
    },
    DealsColumn: {
        isProduct: {
            true: "",
            false: "isProduct [&.isProduct]:flex-row [&.isProduct]:justify-between [&.isProduct]:items-center [&.isProduct]:w-full"
        },
        fullWidth: {
            true: "w-full",
            false: ""
        }
    },
    DealsProductDescription: {
        inSwiper: {
            true: "h-16 phone:h-[4.5rem]",
            false: ""
        }
    },
    DealsSecondaryValue: {
        discount: {
            true: "line-through",
            false: ""
        }
    }
};
var DealsBoxWrapper = function(_param) {
    var limitMaxWidth = _param.limitMaxWidth, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "limitMaxWidth",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mx-0 mt-[-1px] flex w-full place-content-center bg-mglGray50 px-0 py-10", limitMaxWidth != undefined && variants.DealsBoxWrapper.limitMaxWidth[limitMaxWidth.toString()])
    }, rest), {
        children: children
    }));
};
var DealsBoxContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "flex w-full flex-col gap-y-4"
    }, rest), {
        children: children
    }));
};
var DealsBoxTitleContainer = function(_param) {
    var shouldRenderAds = _param.shouldRenderAds, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "shouldRenderAds",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: shouldRenderAds != undefined && variants.DealsBoxTitleContainer.noPadding[(!shouldRenderAds).toString()]
    }, rest), {
        children: children
    }));
};
var DealsBoxTitle = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "text-2xl font-medium text-mglGray900"
    }, rest), {
        children: children
    }));
};
var DealsBoxSubheading = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "pt-1 text-sm text-mglGray900"
    }, rest), {
        children: children
    }));
};
var DealsChipButtonContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-4 flex self-end [&>div>span>svg>path]:border [&>div>span>svg>path]:border-solid [&>div>span>svg>path]:border-mglGray50 [&>div>span>svg>path]:stroke-[3] [&>div]:border [&>div]:border-solid [&>div]:border-mglGray400 [&>div]:px-6 [&>div]:py-0 [&>div]:transition-all [&>div]:duration-300 [&>div]:ease-ease [&>div]:hover:border-mglGray900"
    }, rest), {
        children: children
    }));
};
var DealsUnitContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "[&.chip-button>span>svg]:bg-MglGreen600 relative flex h-full w-full items-center gap-x-4 rounded bg-mglGray50 p-4 shadow-mdc-elevation-z9-3 transition-shadow duration-300 ease-ease hover:shadow-mdc-elevation-z4-3 [&.chip-button>span>svg]:text-mglGray50 [&.chip-button>svg>path]:border-[1.5px] [&.chip-button>svg>path]:border-solid [&.chip-button>svg>path]:border-mglGray50 [&.chip-button>svg>path]:stroke-[3] [&.chip-button>svg]:transition-all [&.chip-button>svg]:duration-300 [&.chip-button>svg]:ease-ease [&.chip-button]:bg-mglGreen600 [&>svg]:last:text-xl"
    }, rest), {
        children: children
    }));
};
var DealsProductImageContainer = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex flex-col justify-between [&_img]:h-[76px] [&_img]:w-[76px] [&_img]:rounded", className)
    }, rest), {
        children: children
    }));
};
var DealsRow = function(_param) {
    var children = _param.children, isProduct = _param.isProduct, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "isProduct"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex w-full items-start justify-between gap-4 tablet:items-center", isProduct != undefined && variants.DealsRow.isProduct[isProduct.toString()])
    }, rest), {
        children: children
    }));
};
var DealsColumn = function(_param) {
    var children = _param.children, fullWidth = _param.fullWidth, isProduct = _param.isProduct, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "fullWidth",
        "isProduct"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex flex-col gap-y-2 [&_.chip-button]:gap-2 [&_.chip-button]:transition-all [&_.chip-button]:duration-300 [&_.chip-button]:ease-ease [&_.chip-button_path]:transition-all [&_.chip-button_path]:duration-300 [&_.chip-button_path]:ease-ease", isProduct != undefined && variants.DealsColumn.isProduct[isProduct.toString()], fullWidth != undefined && variants.DealsColumn.fullWidth[fullWidth.toString()])
    }, rest), {
        children: children
    }));
};
var DealsPartnerContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "flex w-full items-center justify-between gap-x-6 phone:w-auto phone:justify-start"
    }, rest), {
        children: children
    }));
};
var DealsProductDescription = function(_param) {
    var children = _param.children, inSwiper = _param.inSwiper, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "inSwiper"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("line-clamp-3  max-h-[2.8em] w-full text-ellipsis text-sm font-normal leading-[1.4em] text-mglGray800  tablet:text-base", inSwiper != undefined && variants.DealsProductDescription.inSwiper[inSwiper.toString()])
    }, rest), {
        children: children
    }));
};
var DealsValueContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "flex flex-col justify-between gap-x-4 whitespace-nowrap phone:justify-start phone:gap-x-0"
    }, rest), {
        children: children
    }));
};
var DealsValue = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "text-lg font-medium leading-tight text-mglBlue400"
    }, rest), {
        children: children
    }));
};
var DealsSecondaryValue = function(_param) {
    var children = _param.children, discount = _param.discount, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "discount"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("text-xs leading-tight text-mglBlue400", discount != undefined && variants.DealsSecondaryValue.discount[discount.toString()])
    }, rest), {
        children: children
    }));
};
var DealsCents = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "align-text-top text-xs"
    }, rest), {
        children: children
    }));
};
var DealsContentContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mb-6 [&>h4]:text-lg [&>h4]:desktop:text-2xl"
    }, rest), {
        children: children
    }));
};
var DealsContentTitle = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mb-4 font-bold text-mglGray900 [&#title-oferta]:text-2xl"
    }, rest), {
        children: children
    }));
};
var DealsContentWrapper = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "flex flex-col rounded-lg border border-solid border-mglGray200 bg-white px-4 py-0 shadow-mdc-elevation-z9-3"
    }, rest), {
        children: children
    }));
};
var DealsContentLink = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex w-full items-center justify-between gap-4 gap-x-2 gap-y-4 phone:gap-0 [&_figure>div>img]:rounded [&_figure]:shrink-0 [&_figure]:grow-0 [&_figure]:basis-[76px]", className)
    }, rest), {
        children: children
    }));
};
var DealsContentUnitContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "block list-none border-x-0 border-b-0 p-2 px-0 py-4 [&+li]:border-t [&+li]:border-solid [&+li]:border-mglGray100 [&.bloco-zoom>a]:shadow-none [&.bloco-zoom>a]:hover:shadow-none [&.bloco-zoom]:m-0"
    }, rest), {
        children: children
    }));
};
var DealsContentTextContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "flex w-full flex-col items-center justify-between gap-4 gap-x-2 gap-y-4 phone:flex-row phone:gap-0 [&>.chip-button]:w-full [&>.chip-button]:font-medium [&>.chip-button]:phone:w-auto [&_figure>div>img]:rounded [&_figure]:shrink-0 [&_figure]:grow-0 [&_figure]:basis-[76px]"
    }, rest), {
        children: children
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 8157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedProductExclusive; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function FeaturedProductExclusive(param) {
    var _onHome = param.onHome, onHome = _onHome === void 0 ? false : _onHome;
    var textsLinks = {
        onHome: {
            title: "Sobre OPPO",
            subtitle: null,
            describe: "Junte-se \xe0 OPPO e transforme cada momento em algo extraordin\xe1rio.",
            link: "/oppo"
        },
        onLp: {
            title: "Ofertas OPPO",
            subtitle: "As Melhores ofertas",
            describe: "Aproveite as ofertas exclusivas em produtos OPPO e eleve sua experi\xeancia tecnol\xf3gica.",
            link: "https://ofertas.canaltech.com.br/marca/oppo/"
        }
    };
    var backgroundOppo = "https://t.ctcdn.com.br/QFdnjPQOAnsY-aHSkABkXT-BcN4=/i1068821.jpeg";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex w-full gap-5 phone:flex-col"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: onHome ? textsLinks.onHome.link : textsLinks.onLp.link,
            title: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
            target: "_blank",
            className: "group w-full no-underline",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex h-[375px] flex-col items-center justify-center overflow-hidden", "before:absolute before:bottom-0 before:left-0 before:right-0", "before:top-0 before:z-[1] before:bg-black/60 before:content-['']", onHome && "rounded-2xl"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative h-full w-full transition-all duration-300 ease-in-out group-hover:scale-105",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "img-prod-exclusive opacity-60",
                            src: backgroundOppo,
                            alt: "Smartphone Oppo com tampa traseira transparente mostrando componentes internos e c\xe2meras em destaque, com inscri\xe7\xe3o Powered by MariSilicon sobre fundo preto."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute z-[1] flex h-full flex-col items-center justify-center py-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex border-mglGray50",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "img-prod-exclusive opacity-60",
                                    width: 190,
                                    height: 45,
                                    src: "/oppo-logo.png",
                                    alt: "none"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "py-6",
                                children: [
                                    !onHome && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-center text-2xl font-bold text-mglGray50",
                                        children: textsLinks.onLp.subtitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "max-w-[280px] text-center text-base text-mglGray50 sm:max-w-full",
                                        children: onHome ? textsLinks.onHome.describe : textsLinks.onLp.describe
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "rounded-full border-0 px-8 py-4 text-2xl shadow-[0_3px_0_0_#0086ff]",
                                texto: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
                                color: "black",
                                title: onHome ? textsLinks.onHome.title : textsLinks.onLp.title,
                                borderColor: "white",
                                chipSize: "medium",
                                backgroundColor: "white",
                                link: onHome ? textsLinks.onHome.link : textsLinks.onLp.link,
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        ]
                    })
                ]
            })
        }, "#")
    });
}


/***/ }),

/***/ 8163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/Home/FeaturedNews/index.tsx + 1 modules
var FeaturedNews = __webpack_require__(422);
// EXTERNAL MODULE: ./src/components/Home/FeaturedVideos/index.tsx
var FeaturedVideos = __webpack_require__(167);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./src/components/Layout/ItemListLastNews/styles.tsx
var styles = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/Internals/OfferBanner/index.tsx
var OfferBanner = __webpack_require__(7586);
// EXTERNAL MODULE: ./src/components/Home/FeaturedProducts/index.tsx
var FeaturedProducts = __webpack_require__(2909);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./src/components/Layout/Title/index.tsx
var Title = __webpack_require__(9879);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(5186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(2997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/utils/getValue.ts + 1 modules
var getValue = __webpack_require__(2036);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
// EXTERNAL MODULE: ./src/utils/currencyParser.ts
var currencyParser = __webpack_require__(8745);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/components/Layout/DealsBox/styles.tsx
var DealsBox_styles = __webpack_require__(1167);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedDeals/index.tsx
















core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    autoplay/* default */.Z
]);
function FeaturedDeals(param) {
    var _indexComponent = param.indexComponent, indexComponent = _indexComponent === void 0 ? "" : _indexComponent, _deals = param.deals, deals = _deals === void 0 ? [] : _deals;
    var pagination = {
        clickable: true
    };
    var navigation = {
        nextEl: "#ofertas-swiper-button__next".concat(indexComponent),
        prevEl: "#ofertas-swiper-button__prev".concat(indexComponent)
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref[0];
    var generatePriceText = function(price) {
        switch(price.tipo){
            case 0:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsValue */.hU, {
                    children: "Gr\xe1tis"
                });
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsSecondaryValue */.B, {
                            children: "A partir de"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsValue */.hU, {
                            children: [
                                "R$ ",
                                (0,getValue/* default */.Z)(price.valor).split(",")[0],
                                ",",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsCents */.kx, {
                                    children: "".concat((0,getValue/* default */.Z)(price.valor).split(",")[1])
                                })
                            ]
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsSecondaryValue */.B, {
                            discount: true,
                            children: (0,currencyParser/* default */.Z)(price.valorOriginal)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsValue */.hU, {
                            children: [
                                "R$ ",
                                (0,getValue/* default */.Z)(price.valor).split(",")[0],
                                ",",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsCents */.kx, {
                                    children: "".concat((0,getValue/* default */.Z)(price.valor).split(",")[1])
                                })
                            ]
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsValue */.hU, {
                            children: [
                                "R$ ",
                                (0,getValue/* default */.Z)(price.valor).split(",")[0],
                                ",",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsCents */.kx, {
                                    children: "".concat((0,getValue/* default */.Z)(price.valor).split(",")[1])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsSecondaryValue */.B, {
                            children: [
                                "Em ",
                                price.parcelas,
                                "x sem juros"
                            ]
                        })
                    ]
                });
            case 4:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsSecondaryValue */.B, {
                            children: [
                                "Em ",
                                price.parcelas,
                                "x de"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsValue */.hU, {
                            children: [
                                "R$ ",
                                (0,getValue/* default */.Z)(price.valor).split(",")[0],
                                ",",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsCents */.kx, {
                                    children: "".concat((0,getValue/* default */.Z)(price.valor).split(",")[1])
                                })
                            ]
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    };
    var getTopOfferURL = function(url) {
        try {
            var topOfferURL = new URL(url);
            topOfferURL.searchParams.set("utm_source", "top10home");
            return topOfferURL.toString();
        } catch (err) {
            if ((0,_instanceof/* default */.Z)(err, TypeError)) return "";
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        backgroundColor: designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
        isOnHeader: true,
        paddingOnBottom: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                texto: "\uD83D\uDED2 Top 10 no CT Ofertas",
                color: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mt-4 [&_.container-swiper\\_\\_next]:-right-2 [&_.container-swiper\\_\\_prev]:-left-2 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:transition-opacity [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-in-out [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:w-[26px] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:bg-mglBlue400 [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                        centeredSlidesBounds: true,
                        speed: 1000,
                        pagination: pagination,
                        navigation: navigation,
                        breakpoints: {
                            320: {
                                slidesPerView: 1,
                                slidesPerGroup: 1,
                                spaceBetween: 16
                            },
                            768: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                                spaceBetween: 16
                            },
                            1280: {
                                slidesPerView: 2.5,
                                slidesPerGroup: 3,
                                spaceBetween: 16
                            },
                            1660: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                                spaceBetween: 16
                            }
                        },
                        children: deals.map(function(deal) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                className: "relative h-[180px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: getTopOfferURL(deal.url),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsUnitContainer */.Y9, {
                                        href: getTopOfferURL(deal.url),
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsProductImageContainer */.QG, {
                                                className: "self-baseline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: deal.imagens[300],
                                                    blurhash: deal.blurhash,
                                                    alt: deal.titulo,
                                                    height: 76,
                                                    width: 76
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsRow */.t3, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsColumn */.Wy, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsPartnerContainer */.qr, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-xs text-mglGray900",
                                                                children: [
                                                                    deal.loja && deal.loja.nome && "Vendido por ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: (deal === null || deal === void 0 ? void 0 : (ref = deal.loja) === null || ref === void 0 ? void 0 : ref.nome) || "Aproveite!"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsProductDescription */.vw, {
                                                            inSwiper: true,
                                                            children: deal.titulo
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DealsBox_styles/* DealsRow */.t3, {
                                                            isProduct: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox_styles/* DealsValueContainer */.vi, {
                                                                    children: generatePriceText(deal.preco)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                                    texto: "ir \xe0 loja",
                                                                    color: "white",
                                                                    backgroundColor: "green",
                                                                    borderColor: "green",
                                                                    hover: "green",
                                                                    className: "chip-button",
                                                                    chipSize: "medium",
                                                                    posIcon: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                        icon: "mdi:open-in-new",
                                                                        fontSize: "0.75rem"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, getTopOfferURL(deal.url));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container-swiper container-swiper__prev",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "ofertas-swiper-button__prev".concat(indexComponent),
                            className: "swiper-button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                focusable: "false",
                                width: "1.5em",
                                height: "1.5em",
                                preserveAspectRatio: "xMidYMid meet",
                                viewBox: "0 0 24 24",
                                style: {
                                    verticalAlign: "-0.125em",
                                    transform: "rotate(180deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                    fill: "currentColor"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container-swiper container-swiper__next",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "ofertas-swiper-button__next".concat(indexComponent),
                            className: "swiper-button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                focusable: "false",
                                width: "1.5em",
                                height: "1.5em",
                                preserveAspectRatio: "xMidYMid meet",
                                viewBox: "0 0 24 24",
                                style: {
                                    verticalAlign: "-0.125em",
                                    transform: "rotate(360deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                    fill: "currentColor"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/NewsTimeLine/index.tsx
var NewsTimeLine = __webpack_require__(2835);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedProductsAnalysis/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/alt-text */ 







var publicRuntimeConfig = config_default()().publicRuntimeConfig;
core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    autoplay/* default */.Z
]);
function FeaturedProductsAnalysis(param) {
    var featuredProductsAnalysis = param.featuredProductsAnalysis, bgColor = param.bgColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? true : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var MAX_PRODUCTS_TO_SHOW = 12;
    var pagination = {
        clickable: false
    };
    var PropMetaInfo = {
        age: false,
        category: false
    };
    var PropTitle = {
        altColorInHover: true,
        colorHover: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
    };
    var PropAutor = {
        image: true,
        imgInImage: true,
        imgRounded: true,
        text: false
    };
    var navigation = {
        nextEl: "#analises-swiper-button__next",
        prevEl: "#analises-swiper-button__prev"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
            backgroundColor: bgColor || designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
            isOnHeader: isOnHeader,
            paddingOnBottom: paddingOnBottom,
            paddingOnTop: paddingOnTop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    texto: "An\xe1lises",
                    urlRedirect: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL, "/analises/") : "/analises/",
                    color: "black",
                    showChip: true,
                    alignRight: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative [&_.container-swiper\\_\\_next]:-right-2 [&_.container-swiper\\_\\_prev]:-left-2 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:transition-opacity [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-ease [&_.swiper-button]:bottom-[14%] [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:w-[26px] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:bg-mglBlue400 [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_swiper-wrapper]:m-0 [&_swiper-wrapper]:mb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            slidesPerView: 6,
                            spaceBetween: 14,
                            slidesPerGroup: 6,
                            speed: 1000,
                            pagination: pagination,
                            navigation: navigation,
                            breakpoints: {
                                240: {
                                    slidesPerView: 1,
                                    slidesPerGroup: 1,
                                    spaceBetween: 16
                                },
                                768: {
                                    slidesPerView: 2,
                                    slidesPerGroup: 2,
                                    spaceBetween: 16
                                },
                                1660: {
                                    slidesPerView: 3,
                                    slidesPerGroup: 3,
                                    spaceBetween: 16
                                }
                            },
                            children: featuredProductsAnalysis.slice(0, MAX_PRODUCTS_TO_SHOW).map(function(product) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                                        news: product,
                                        title: true,
                                        propsTitle: PropTitle,
                                        effectImage: true,
                                        metaInfo: true,
                                        propsMetaInfo: PropMetaInfo,
                                        autor: true,
                                        propsAutor: PropAutor,
                                        isSubDomain: isSubDomain,
                                        headingTag: "h3"
                                    }, product.url)
                                }, product.url);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container-swiper container-swiper__prev",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "analises-swiper-button__prev",
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(180deg)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container-swiper container-swiper__next",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "analises-swiper-button__next",
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(360deg)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedCategories/index.tsx





function FeaturedCategories(param) {
    var featuredCategoriesData = param.featuredCategoriesData;
    var PropTitle = {
        color: "darkText",
        altColorInHover: true,
        colorHover: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        backgroundColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
        paddingOnBottom: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                texto: featuredCategoriesData[0].nome,
                urlRedirect: featuredCategoriesData[0].url,
                color: "black",
                showChip: true,
                alignRight: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 grid-rows-1 gap-4 [grid-auto-columns:1fr] phone:grid-cols-2 desktop:grid-cols-3 [&_article]:[@media_screen_and_(max-width:767px)]:[grid-column-end:3] [&_article]:[@media_screen_and_(max-width:767px)]:[grid-column-start:1] first:[&_article]:[@media_screen_and_(max-width:992px)]:[grid-column-end:3] first:[&_article]:[@media_screen_and_(max-width:992px)]:[grid-column-start:1]",
                children: featuredCategoriesData[0].itens.map(function(n) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                        news: n,
                        propsTitle: PropTitle,
                        headingTag: "h3"
                    }, n.url);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 gap-x-[36px] gap-y-6 desktop:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    texto: featuredCategoriesData[1].nome,
                                    urlRedirect: featuredCategoriesData[1].url,
                                    color: "black",
                                    showChip: true,
                                    alignRight: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 grid-rows-1 gap-4 tablet:grid-cols-2",
                                    children: featuredCategoriesData[1].itens.map(function(n) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                                            news: n,
                                            propsTitle: PropTitle,
                                            headingTag: "h3"
                                        }, n.url);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    texto: featuredCategoriesData[2].nome,
                                    urlRedirect: featuredCategoriesData[2].url,
                                    color: "black",
                                    showChip: true,
                                    alignRight: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 grid-rows-1 gap-4 tablet:grid-cols-2",
                                    children: featuredCategoriesData[2].itens.map(function(n) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                                            news: n,
                                            propsTitle: PropTitle,
                                            headingTag: "h3"
                                        }, n.url);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Home/FeaturedCategory/index.tsx





function FeaturedCategory(param) {
    var featuredCategory = param.featuredCategory;
    var PropTitle = {
        color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        backgroundColor: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400,
        paddingOnBottom: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                texto: featuredCategory.nome,
                urlRedirect: featuredCategory.url,
                color: "white",
                alignRight: true,
                showChip: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-0 grid grid-cols-1 grid-rows-5 gap-5 [grid-auto-columns:1fr] tablet:grid-cols-2 tablet:grid-rows-3 desktop:grid-cols-3 desktop:grid-rows-2",
                children: featuredCategory.itens.map(function(n) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                        news: n,
                        propsTitle: PropTitle
                    }, n.url);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Home/FeaturedColuna/index.tsx





var PropAutor = {
    text: true,
    image: true,
    imgInImage: true,
    imgRounded: true
};
function FeaturedColuna(param) {
    var featuredColumnistData = param.featuredColumnistData;
    var PropTitle = {
        color: "darkText",
        altColorInHover: true,
        colorHover: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        backgroundColor: designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
        paddingOnBottom: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                texto: "Colunas",
                urlRedirect: "/colunas/",
                color: "black",
                showChip: true,
                alignRight: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:grid-cols-2 desktop:grid-cols-4 desktop:grid-rows-1",
                children: featuredColumnistData.map(function(n) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                        news: n,
                        propsTitle: PropTitle,
                        autor: true,
                        propsAutor: PropAutor,
                        headingTag: "h3"
                    }, n.url);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Home/FeaturedEditorialCategory/index.tsx + 3 modules
var FeaturedEditorialCategory = __webpack_require__(3393);
// EXTERNAL MODULE: ./src/components/Layout/FeaturedProductExclusive/index.tsx
var FeaturedProductExclusive = __webpack_require__(8157);
;// CONCATENATED MODULE: ./src/pages/index.tsx





















var __N_SSP = true;
function Home(param) {
    var homeData = param.homeData, navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, _schema = param.schema, schema = _schema === void 0 ? null : _schema;
    var AdsTypeGenerators = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 2801).then(__webpack_require__.bind(__webpack_require__, 2801));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2801)
                ];
            }
        },
        ssr: false
    });
    var FeaturedLastNews = dynamic_default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(3970), __webpack_require__.e(2826), __webpack_require__.e(8662)]).then(__webpack_require__.bind(__webpack_require__, 2826));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2826)
                ];
            }
        },
        ssr: false
    });
    var shouldRender = function(key) {
        var value = homeData[key];
        return Array.isArray(value) && value.length > 0;
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        layoutData: {
            segmentacoes: segmentacoes,
            tagsData: tagsData,
            navBarData: navBarData,
            schema: schema
        },
        headingTag: "h1",
        dataLayer: {
            contentType: "home"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBanner/* default */.Z, {
                isOnHome: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedNews/* default */.Z, {
                featuredNewsData: homeData.vitrine
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedVideos["default"], {
                featuredVideosData: homeData.videos
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
                paddingOnBottom: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProductExclusive/* default */.Z, {
                    onHome: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AdContainer */.g1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGenerators, {
                        type: "billboard/main/home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGenerators, {
                        type: "rectangle/main/home"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts["default"], {
                featuredProductsData: homeData.produtos
            }),
            shouldRender("topOffers") && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedDeals, {
                deals: homeData.topOffers
            }),
            shouldRender("manualAnalysis") && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProductsAnalysis, {
                featuredProductsAnalysis: homeData.manualAnalysis,
                paddingOnBottom: true,
                bgColor: designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
                isOnHeader: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AdContainer */.g1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "billboard/main/home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "rectangle/main/home"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCategories, {
                featuredCategoriesData: homeData.categoria3
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AdContainer */.g1, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                    type: "rectangle/main/home"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCategory, {
                featuredCategory: homeData.categoria1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AdContainer */.g1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "billboard/main/home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "rectangle/main/home"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedColuna, {
                featuredColumnistData: homeData.colunistas
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AdContainer */.g1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "billboard/main/home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "rectangle/main/home"
                    })
                ]
            }),
            shouldRender("ctup") && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedEditorialCategory/* default */.Z, {
                variant: "ctup",
                timeline: homeData.ctup.slice(0, 6)
            }),
            shouldRender("ctEletro") && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedEditorialCategory/* default */.Z, {
                variant: "eletro",
                timeline: homeData.ctEletro.slice(0, 6)
            }),
            shouldRender("ctauto") && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedEditorialCategory/* default */.Z, {
                variant: "ctauto",
                timeline: homeData.ctauto.slice(0, 6)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* AdContainer */.g1, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "billboard/main/home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "rectangle/main/home"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                height: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedLastNews, {
                    rootPage: "/",
                    textTitle: "\xdaltimas Not\xedcias",
                    route: "",
                    routeType: "ultimas"
                })
            })
        ]
    });
}


/***/ }),

/***/ 8745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ currencyParser; }
/* harmony export */ });
function currencyParser(value) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(value);
}


/***/ }),

/***/ 2036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getValue; }
});

;// CONCATENATED MODULE: ./src/utils/replaceAll.ts
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}

;// CONCATENATED MODULE: ./src/utils/getValue.ts

function getValue(preco) {
    var value = preco.toString();
    var price = [];
    var fullPrice = value.split(".")[0] ? value.split(".")[0] : value;
    var priceLength = value.split(".")[0].length ? value.split(".")[0].length : value.length;
    var counter = 0;
    for(var i = priceLength - 1; i >= 0; i -= 1){
        if (counter !== 0 && counter % 3 === 0) price.push(".");
        counter += 1;
        price.push(fullPrice[i]);
    }
    var getPrice = function() {
        return replaceAll(price.reverse().toString(), ",", "");
    };
    if (value.includes(".")) {
        var cents = value.split(".")[1];
        var getCents = function() {
            return cents.length >= 2 ? cents : "".concat(cents, "0");
        };
        return "".concat(getPrice(), ",").concat(getCents());
    }
    return "".concat(getPrice(), ",00");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5810,1216,9491,3213,7637,7724,5344,7590,944,8814,1067,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);